import React from "react";
import { AppBar, Toolbar, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setDate } from "../../redux/slice/date";
import { DateRangePicker } from "../filters/DateRangePicker";
import moment from "moment";
import { setMenuType } from "../../redux/slice/menuType";
import { useNavigate } from "react-router-dom";
import UserToggleSwitch from "./ToggleSwitch";
import { useAuth } from "../../context/AuthContext";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";
import YearPicker from "../filters/DateRangePicker/YearSelector";

const Header = ({ disableSelection, onYearPickerChange }) => {
    const { user } = useAuth();
    const dateRange = useSelector((state) => state.date);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const menuType = useSelector((state) => state.menuType);
    const { getFontSize, getSectionStyle } = useResponsiveStyles();

    const handleMenuTypeChange = (type) => {
        dispatch(setMenuType(type));
        if (type === "admin") {
            navigate("/admin/input-sheets");
        } else {
            navigate("/dashboard");
        }
    };

    const handleDateRangeChange = (startDate, endDate) => {
        dispatch(
            setDate({
                startDate: startDate,
                endDate: endDate,
            })
        );
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: "white",
                color: "black",
                boxShadow: "3.6px 0px 27px 0px #00000014",
                p: 0,
                m: 0,
            }}
        >
            <Toolbar
                sx={{
                    minHeight: { xs: "0px", sm: "0px" },
                    justifyContent: "space-between",
                    p: "0.2rem",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <img
                        src="/images/ambit-logo.png"
                        alt="AMBIT Logo"
                        className="h-8"
                    />
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        whiteSpace: "nowrap",
                    }}
                >
                    {user?.role === "admin" && (
                        <UserToggleSwitch
                            checked={menuType === "research" ? false : true}
                            onChange={() => {
                                handleMenuTypeChange(
                                    menuType === "research"
                                        ? "admin"
                                        : "research"
                                );
                            }}
                        />
                    )}
                    {/* <img
                        src="/icons/notifications.svg"
                        alt="Notifications"
                        className="mr-6"
                    /> */}
                    {menuType !== "admin" && (
                        <div
                            className="flex items-center"
                            style={getSectionStyle("filter-section")}
                        >
                            <span className="mr-2" style={getFontSize("body1")}>
                                Showing data for:
                            </span>
                            {onYearPickerChange ? (
                                <YearPicker onChange={onYearPickerChange}/>
                            ) : (
                                <DateRangePicker
                                dateRange={{
                                    startDate: dateRange.startDate,
                                    endDate: dateRange.endDate,
                                }}
                                onDateRangeChange={handleDateRangeChange}
                                borderColor={disableSelection ? "#939598" : "#ED1C24"}
                                disableDateRangeSelection={disableSelection}
                                />
                            )}
                        </div>
                    )}
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
